export default __webpack_public_path__ + "static/media/bg3.850b8088.jpg";